import React from "react";
import "./TabsSkeleton.css";

const TabsSkeleton = () => {
  // We'll show 3 tab headers + 4–6 skeleton news items
  return (
    <div className="tabs-skeleton-container">
      {/* Tab Header */}
      <div className="tabs-skeleton-header">
        <div className="tab-skeleton shimmer"></div>
        <div className="tab-skeleton shimmer"></div>
        <div className="tab-skeleton shimmer"></div>
      </div>

      {/* Skeleton Articles */}
      <div className="tabs-skeleton-content">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="tabs-skeleton-item">
            <div className="skeleton-thumb shimmer"></div>
            <div className="skeleton-text shimmer" style={{ width: "70%" }}></div>
            <div className="skeleton-text shimmer" style={{ width: "50%" }}></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TabsSkeleton;
